import { BarChart } from '@mui/x-charts/BarChart';

// Same chart library as the device telemetry charts (DeviceHealthModal),
// skinned to the stats-card design: peak bar in primary, the rest tinted.
const StatBars: React.FC<{
    values: number[];
    /** Unique category names; shown in the tooltip. */
    categories: string[];
    /** Axis tick text per category ('' hides the tick). */
    tickLabel: (category: string, index: number) => string;
    borderRadius: number;
    height: number;
    categoryGapRatio: number;
}> = ({ values, categories, tickLabel, borderRadius, height, categoryGapRatio }) => {
    const max = Math.max(...values);
    return (
        <BarChart
            height={height}
            // Side margins leave room for the edge tick labels, which MUI
            // otherwise ellipsizes against the drawing-area bounds.
            margin={{ top: 4, bottom: 0, left: 8, right: 8 }}
            hideLegend
            borderRadius={borderRadius}
            series={[{ data: values }]}
            xAxis={[{
                scaleType: 'band',
                data: categories,
                categoryGapRatio,
                disableLine: true,
                disableTicks: true,
                // Most hour ticks are blank; without this the auto interval
                // also drops the edge labels (00/23) as "overlapping".
                tickLabelInterval: () => true,
                valueFormatter: (value: string, context: { location: string }) => (
                    context.location === 'tick' ? tickLabel(value, categories.indexOf(value)) : value
                ),
                colorMap: {
                    type: 'ordinal',
                    colors: values.map((value) => (
                        value === max ? 'var(--ion-color-primary)' : 'rgba(var(--ion-color-primary-rgb), 0.22)'
                    ))
                }
            }]}
            yAxis={[{ position: 'none' }]}
            sx={{ '& .MuiChartsAxis-tickLabel': { fill: 'var(--ion-color-medium)', fontSize: 10.5 } }}
        />
    );
};

export default StatBars;
